<template>
  <div class="field-customize">
    <!-- 新增标签表单 -->
    <FormAddLabel
      @addNewLable="addNewLable"
      @cancel="closewin"
      v-if="addLabelVisible"
      @upd="getData"
    ></FormAddLabel>
    <h1 class="title">定制化主题</h1>
    <div class="main">
      <div class="theme">
        <span class="label">主题:</span><input type="text" v-model="theme" style="padding-left:9px"/>
      </div>
      <div class="modular">
        <span class="label">模块:</span>
        <div class="content-wrapper">
          <div class="selected">
            <div class="area-label">已添加</div>
            <div class="selected-area">
              <TypeItem
                v-for="(item, index) in selectedList"
                :name="item"
                :index="index"
                :key="index"
                :close-enable="true"
                @deleteItem="deleteItem"
              ></TypeItem>
            </div>
          </div>
          <div class="select">
            <div class="add-option-item">
              <i class="el-icon-plus" @click="showAddLableForm"></i>
            </div>
            <div class="area-label">可添加</div>
            <div class="select-area">
              <TypeItem
                v-for="(item, index) in enableSelecteList"
                :name="item.name"
                :index="index"
                :key="index"
                :close-enable="false"
                @handleSelected="handleSelected"
              ></TypeItem>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="btn add" @click="handleAdd">添加</div>
        <div class="btn cancel" style="margin-left: 3vw" @click="handleCancel">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
import TypeItem from "@/components/FieldCustomize/TypeItem"
import FormAddLabel from "@/components/FieldCustomize/FormAddLabel"
import api from "@/services/python" 
export default {
  components: {
    TypeItem,
    FormAddLabel,
  },
  data() {
    return {
      theme: "",
      addLabelVisible: false,
      selectedList: [
        //  "理论",
        // "政策法规",
        // "技术",
        // "行业应用",
        // "人才培养",
        // "产品",
        // "项目",
        // "科技成果",
      ],
      enableSelecteList: [
        //  "理论",
        // "政策法规",
        // "技术",
        // "行业应用",
        // "人才培养",
        // "产品",
        // "项目",
        // "科技成果",
      ],
      defaultItemList: [],
    }
  },
  created() {
    this.getData();
  },
  methods: {
    closewin() {
      this.addLabelVisible = false;
      // 自刷新
      this.getData();
    },
    closeMessageBox(){
      this.$emit("cancel")
    },
    handleSelected(param) {
      const { index, name } = param
      this.enableSelecteList.splice(index, 1)
      this.selectedList.push(name)
    },
    deleteItem(index) {
      let name = this.selectedList[index]
      this.selectedList.splice(index, 1)
      this.enableSelecteList.push(name)
    },
    handleCancel() {
      this.$emit("cancel")
      this.reset()
    },
  async handleAdd() {
      if (!this.theme) {
        alert("请输入领域名称!")
        return
      }
      // this.$emit("handleAddCustomizedField", {
      //   name: this.theme,
      //   selectedList: [...this.selectedList],
      // })
       const params = {
        name:this.theme,
        "id": 0,
        "created_at": "2022-05-30T06:38:24.311Z",
        "updated_at": "2022-05-30T06:38:24.311Z"
       }
       const res =await api.domains.create(params).response.then(res => res.data)
       if(res.code == 200){
        this.$message({
          message: '添加成功',
          type: 'success',
        });
       }else{
          this.$message.error('添加失败');
       }
       this.theme === "";//清空字段
       this.$emit("cancel");//关闭弹窗
      // this.reset()
    },
    //显示新增子标签表单
    showAddLableForm() {
      this.addLabelVisible = true
    },
    //执行添加新标签
    addNewLable(value) {
      this.enableSelecteList.push(value)
      this.addLabelVisible = false
    },
    reset() {
      //确定之后初始化
      this.theme = ""
      this.enableSelecteList = [...this.defaultItemList]
      this.selectedList = []
    },
    async getData(){
      const params = {
        page_size:100,
        page_to:1
      }
      const res =await api.keywords.list({},{params}).response.then(res => res.data)
      if(res.code == 200){
        this.enableSelecteList = res.data.records
        console.log('this.enableSelecteList',this.enableSelecteList);
      }
    },
  },
}
</script>

<style lang="scss">
$border: 2px solid #aaa;
$inner-border: 1px solid #aaa;
$innerLight: rgba(
  $color: #bce6ec,
  $alpha: 0.5,
);
.field-customize {
  background-color: transparent;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  & .title {
    position: relative;
    top: -10%;
  }

  & .main {
    position: relative;
    height: 55%;
    width: 40%;
    border-radius: 10px;
    border: $border;
    box-sizing: border-box;
    padding: 2vw;
    display: flex;
    flex-direction: column;
    & .label {
      font-size: 14px;
      margin-right: 10px;
    }
    & .theme {
      & input {
        border: $inner-border;
        height: 3vh;
        width: 60%;
        border-radius: 8px;
        color: #eee;
        font-size: 14px;
      }
      margin-bottom: 20px;
    }
    & .modular {
      height: 70%;
      display: flex;
      & .content-wrapper {
        display: inline-block;
        height: 100%;
        width: 90%;
        border: $inner-border;
        border-radius: 8px;
        & .type-item:not(:nth-of-type(5n)) {
          margin-right: 2%;
        }
        & .area-label {
          position: absolute;
          left: 2%;
          top: -10%;
          z-index: 2;
        }
        // & .selected-area,
        // & .select-area {
        //   overflow: auto;
        // }
        & .selected {
          position: relative;
          // padding: 4%;
          height: 40%;
          line-height: 6vh;
          box-sizing: border-box;
          border-bottom: $inner-border;
          padding-right: 3px;
          & .selected-area {
            padding: 4%;
            overflow: auto;
            height: 100%;
            box-sizing: border-box;
          }
        }
        & .select {
          position: relative;
          // padding: 4%;
          height: 60%;
          line-height: 6vh;
          padding-right: 3px;
          box-sizing: border-box;
          & .add-option-item {
            position: absolute;
            right: 3%;
            top: -10%;
            z-index: 2;
            font-size: 16px;
            cursor: pointer;
            transform: scale(1);
            transition: transform 0.2s linear;
            &:hover {
              transform: scale(1.2);
            }
          }
          & .select-area {
            padding: 4%;
            overflow: auto;
            height: 100%;
            box-sizing: border-box;
          }
        }
      }
    }
    & .footer {
      position: absolute;
      bottom: 3%;
      height: 10%;
      //   border: 1px solid black;
      display: flex;
      left: 50%;
      transform: translateX(-50%);
      & .btn {
        width: 5vw;
        height: 80%;
        // border: $inner-border;
        border-radius: 4px;
        font-size: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: 0 0 1em $innerLight inset;
        background-color: rgb(8, 14, 32);
        cursor: pointer;
        &:hover {
          background-color: #212a4b;
        }
      }
    }
  }
}
</style>
